import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer from './ducks';

const configureStore = (initialData = {}) => {
  const middlewares = [thunk];

  const enhancers = [applyMiddleware(...middlewares)];

  return createStore(rootReducer, initialData, composeWithDevTools(...enhancers));
};

export default configureStore;
